import React from "react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Search, X } from "lucide-react";

export const ALL = "__all__";
export const EMPTY_FILTERS = { broker: ALL, category: ALL, status: ALL, search: "" };
export const SORT_OPTIONS = [
  { v: "date_desc", label: "Newest first" },
  { v: "date_asc", label: "Oldest first" },
  { v: "pl_desc", label: "P&L: High → Low" },
  { v: "pl_asc", label: "P&L: Low → High" },
  { v: "broker_asc", label: "Broker A → Z" },
];
const ALL_LABELS = { Broker: "All Brokers", Category: "All Categories", Status: "All Statuses" };

export function hasActiveFilters(f) {
  return f.broker !== ALL || f.category !== ALL || f.status !== ALL || !!f.search;
}

export default function FilterBar({ filters, setFilters, sortBy, setSortBy, reference }) {
  const update = (patch) => setFilters({ ...filters, ...patch });
  return (
    <div className="bg-[#121318] border border-[#27272A] p-3 flex flex-wrap items-center gap-2">
      <div className="relative flex-1 min-w-[200px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-[#71717A]" />
        <Input data-testid="filter-search" placeholder="Search stock…" value={filters.search}
          onChange={(e) => update({ search: e.target.value })}
          className="bg-[#08080A] border-[#27272A] text-white pl-9 rounded-sm uppercase placeholder:text-[#71717A] placeholder:normal-case" />
      </div>
      <FilterSelect label="Broker" value={filters.broker} options={reference?.brokers || []} onChange={(v) => update({ broker: v })} testid="filter-broker" />
      <FilterSelect label="Category" value={filters.category} options={reference?.categories || []} onChange={(v) => update({ category: v })} testid="filter-category" />
      <FilterSelect label="Status" value={filters.status} options={reference?.statuses || []} onChange={(v) => update({ status: v })} testid="filter-status" />
      <Select value={sortBy} onValueChange={setSortBy}>
        <SelectTrigger data-testid="sort-select" className="bg-[#08080A] border-[#27272A] text-white rounded-sm w-[180px] h-9 text-xs">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-[#121318] border-[#27272A] text-white rounded-sm">
          {SORT_OPTIONS.map((o) => (
            <SelectItem key={o.v} value={o.v} className="text-white focus:bg-[#1A1B23] text-xs" data-testid={`sort-${o.v}`}>{o.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      {hasActiveFilters(filters) && (
        <Button data-testid="clear-filters" variant="ghost" size="sm" onClick={() => setFilters(EMPTY_FILTERS)}
          className="text-[#71717A] hover:text-white hover:bg-[#1A1B23] rounded-sm">
          <X className="h-3 w-3 mr-1" /> Clear
        </Button>
      )}
    </div>
  );
}

function FilterSelect({ label, value, options, onChange, testid }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testid} className="bg-[#08080A] border-[#27272A] text-white rounded-sm w-[160px] h-9 text-xs">
        <SelectValue placeholder={label} />
      </SelectTrigger>
      <SelectContent className="bg-[#121318] border-[#27272A] text-white rounded-sm">
        <SelectItem value={ALL} className="text-white focus:bg-[#1A1B23] text-xs">{ALL_LABELS[label]}</SelectItem>
        {options.map((o) => <SelectItem key={o} value={o} className="text-white focus:bg-[#1A1B23] text-xs">{o}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
